module.exports = __webpack_public_path__ + "img/1-1.87bb9ee4.jpg";